import React, { useState, useEffect } from "react";
import { ReactSlider } from 'react-slider-image-js'
import 'react-slider-image-js/dist/index.css'
import $ from 'jquery';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import {MDBInput, MDBTable, MDBTableHead, MDBTableBody} from "mdb-react-ui-kit";
// import "../../Componentes/www/style.css";
import "../../Componentes/www/invoice.css";
import { roundNumber } from "../Util";
import { Container, Row, Col, Label } from "reactstrap";
import {reactLocalStorage} from 'reactjs-localstorage';
import { LOGO, YAPPY_IMAGE_PUBLICIDAD } from "../Image";
 import {get_img_publicidad, imgURLLocalImageIp} from "./../Services";
var x = reactLocalStorage.getObject('tokenP');

export const SegundaPantalla = () => {
    const [dataPublicidad, setDataPublicidad] = useState([]);
    const [flagYappy, setFlagYappy] = useState(false);
    const [flagDatos, setFlagDatos] = useState(false);
    const [storage, setDataStorage] = useState([]);

  async function fetchPublicidad() {
    var response;
    response = await get_img_publicidad();
  
    var ObjItems=[];
    response.map((data)=>{
      ObjItems.push({
        src: imgURLLocalImageIp+data.img_name
      });
      return null;
    })
    setDataPublicidad(ObjItems);
  }

async function fetchStorage() {

  const x = reactLocalStorage.getObject('tokenP');

  setDataStorage(x);

  if (x?.dataFacturaDetallePr?.dataFacturaDetalle !== undefined) {
    setFlagDatos(true);
  } else {
    setFlagDatos(false);
  }

  let xx = false;

  if (x?.dataFacturaDetallePr?.dataListPago) {

    x.dataFacturaDetallePr.dataListPago.find((data) => {

      if (data.list_fpagoName === "PAGO POR YAPPY") {
        xx = true;
        return true;
      }

      return false;
    });
  }

  setFlagYappy(xx);

  setTimeout(() => {
    fetchStorage();
  }, 2000);
}

  useEffect(() => {
    fetchPublicidad();
    fetchStorage();
  }, []);

  var descuento = 0;
  var subtotal = 0;
  var itbms = 0;
  var total = 0;
  if(flagDatos){
    storage.dataFacturaDetallePr.dataFacturaDetalle.map((row) => {
      descuento = Number(descuento) + Number(Number(row.fcd_descuento));
      subtotal = Number(subtotal) + Number(Number(row.fcd_precio) * Number(row.fcd_cantidad));
      itbms = Number(itbms) + Number(row.fcd_itbms);
      total =   Number(total) +Number(row.fcd_total);
      return null;
    });
  }
  if(flagDatos){

  }
subtotal = roundNumber(subtotal,2);
itbms = roundNumber(itbms,2);
total = roundNumber(total,2);
// $(document).ready(function() {
//   $('.top-v').animate({
//       scrollTop: $('.top-v').get(0).scrollHeight
//   }, 600);
// });
  return (
<Container fluid className="customer-screen">
  <Row className="h-100 g-0">
    
    {/* PUBLICIDAD */}
    <Col xs={5} className="customer-ad">
      {dataPublicidad[0] !== undefined ? (
        <ReactSlider
          sliderIndex={0}
          images={dataPublicidad}
          slideAnimationDuration="600ms"
          imageBackgroundColor="rgba(0,0,0,0.9)"
          objectFit="fill"
          isAutoSlide={true}
          autoSlideDuration={15000}
        />
      ) : (
        <img src={LOGO} className="ad-logo" alt="Publicidad" />
      )}
    </Col>

    {/* FACTURA */}
    <Col xs={7} className="customer-panel">
      
      <div className="customer-header">
        <div>
          <div className="info-line">
            <span>CLIENTE:</span>
            <b>{flagDatos ? storage.dataFacturaDetallePr.formClientes.cli_nombre : "--"}</b>
          </div>

          <div className="info-line">
            <span>RUC:</span>
            <b>
              {flagDatos
                ? `${storage.dataFacturaDetallePr.formClientes.cli_ruc} DV: ${storage.dataFacturaDetallePr.formClientes.cli_dv}`
                : "--"}
            </b>
          </div>

          <div className="info-line">
            <span>EMAIL:</span>
            <b>{flagDatos ? storage.dataFacturaDetallePr.formClientes.cli_email : "--"}</b>
          </div>
        </div>

        <div className="date-box">
          <small>FACTURACIÓN</small>
          <strong>{new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</strong>
        </div>
      </div>

      <div className="table-wrapper">
        <MDBTable className="customer-table">
          <MDBTableHead>
            <tr>
              <th>CÓDIGO</th>
              <th>DESCRIPCIÓN</th>
              <th>PRECIO</th>
              <th>CANT.</th>
              <th>DESC.</th>
              <th>TOTAL</th>
            </tr>
          </MDBTableHead>

          <MDBTableBody>
            {flagDatos &&
              storage.dataFacturaDetallePr.dataFacturaDetalle.map((data, i) => (
                <tr key={i}>
                  <td className="code">{data.art_upc}</td>
                  <td>{data.art_descripcion}</td>
                  <td>{Number(data.fcd_precio).toFixed(2)}</td>
                  <td>{Number(data.fcd_cantidad).toFixed(0)}</td>
                  <td>
                    {data.fcd_descuento_number.length > 0
                      ? Number(data.fcd_descuento).toFixed(2)
                      : ""}
                  </td>
                  <td className="total-cell">{Number(data.fcd_total).toFixed(2)}</td>
                </tr>
              ))}
          </MDBTableBody>
        </MDBTable>
      </div>

      <div className="customer-footer">
        <div className="brand-box">
          <img
            src={flagYappy ? YAPPY_IMAGE_PUBLICIDAD : LOGO}
            className="brand-logo"
            alt="Logo"
          />
        </div>

        <div className="totals-box">
          <div className="total-row">
            <span>SUBTOTAL</span>
            <b>{Number(subtotal).toFixed(2)}</b>
          </div>

          <div className="total-row">
            <span>DESCUENTO</span>
            <b>{Number(descuento).toFixed(2)}</b>
          </div>

          <div className="total-row">
            <span>ITBMS</span>
            <b>{Number(itbms).toFixed(2)}</b>
          </div>

          <div className="total-row grand-total">
            <span>TOTAL</span>
            <b>{Number(total).toFixed(2)}</b>
          </div>
        </div>
      </div>

    </Col>
  </Row>
</Container>
  );
};
